// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","logo":"Header_logo__shVBB","nameContainer":"Header_nameContainer__vHlHZ","name":"Header_name__59-C5","status":"Header_status__gqGdR"};